var Conjuration = require('../ability_trees/Conjuration.js');
var Illusion = require('../ability_trees/Illusion.js');
var Spirit = require('../ability_trees/Spirit.js');
const StandardAbilityTree = require('../ability_trees/StandardAbilityTree.js');

var ItemGenerator = require('../../game_items/ItemGenerator.js');
var LightHelmet = require('../../game_items/equipment/helmet/LightHelmet.js');
var LightTorsoe = require('../../game_items/equipment/torsoe/LightTorsoe.js');
var LightBoots = require('../../game_items/equipment/boots/LightBoots.js');
var Staff = require('../../game_items/equipment/weapon/Staff.js');
var Trinket = require('../../game_items/equipment/off_hand/Trinket.js');

module.exports = {
  handle: 'warlock',
  getAbilityTrees: () => ([
    Conjuration,
    Illusion,
    Spirit,
    StandardAbilityTree,
  ]),
  getBaseAttributes: () => ({
    learning: 10,
    perception: 6,
    mana: 10,
    toughness: 5,
    strength: 4,
    willpower: 10,
    dexterity: 5,
  }),
  getDefaultAIConfig: () => (['support', 'interference', 'dps_ranged', 'dps_close', 'tank']),
  getStarterEquipment: () => ({
    helmet: ItemGenerator.getRandomItem(LightHelmet, 0, 0.1, true),
    torsoe: ItemGenerator.getRandomItem(LightTorsoe, 0, 0.1, true),
    boots: ItemGenerator.getRandomItem(LightBoots, 0, 0.1, true),
    weapon: ItemGenerator.getRandomItem(Staff, 0, 0.1, true),
    off_hand: ItemGenerator.getRandomItem(Trinket, 0, 0.1, true),
  }),
};
